export default {
      id: "ic-nav-exit-white-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-exit-white-usage",
      toString: function () {
        return this.url;
      }
    }